import { render } from "./CashPayment.vue?vue&type=template&id=36484a50"
import script from "./CashPayment.vue?vue&type=script&lang=js"
export * from "./CashPayment.vue?vue&type=script&lang=js"

import "./CashPayment.vue?vue&type=style&index=0&id=36484a50&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekalifront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__